import { MessageCircle, Instagram, Facebook, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { waLink } from "@/lib/api";

export function Footer({ content }) {
  return (
    <footer className="border-t border-emerald-500/15 bg-[#050806] pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={content.logoUrl} alt={content.businessName} className="w-12 h-12 rounded-full object-cover ring-2 ring-emerald-500/40" />
            <span className="font-display font-extrabold tracking-tight">{content.businessName}</span>
          </div>
          <p className="text-sm text-gray-500 leading-relaxed max-w-xs">{content.tagline}</p>
          <div className="flex gap-3 mt-5">
            {content.instagram && (
              <a href={content.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="w-9 h-9 rounded-full border border-emerald-500/25 flex items-center justify-center text-gray-400 hover:text-emerald-400 transition-colors duration-200" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
            )}
            {content.facebook && (
              <a href={content.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="w-9 h-9 rounded-full border border-emerald-500/25 flex items-center justify-center text-gray-400 hover:text-emerald-400 transition-colors duration-200" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
            )}
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-emerald-400 mb-4">Contacto directo</h4>
          <a
            href={waLink(content.whatsapp, "Hola, quiero información sobre los suplementos 365 Cellular Energy.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-black font-semibold text-sm px-5 py-2.5 rounded-full transition-colors duration-200"
          >
            <MessageCircle className="w-4 h-4" />
            {content.whatsappDisplay}
          </a>
          <p className="text-xs text-gray-500 mt-4">Atención personalizada, pedidos y envíos.</p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-emerald-400 mb-4">Legal</h4>
          <p className="text-xs text-gray-500 leading-relaxed" data-testid="footer-disclaimer">{content.footerText}</p>
          <Link to="/admin" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 text-xs text-gray-600 hover:text-yellow-500 mt-5 transition-colors duration-200">
            <Lock className="w-3 h-3" /> Acceso administrador
          </Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 pt-6 border-t border-emerald-500/10 flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-gray-600">© {new Date().getFullYear()} {content.businessName}. Todos los derechos reservados.</p>
        <p className="text-[10px] uppercase tracking-[0.25em] text-emerald-500/50">Energía celular · 365 días</p>
      </div>
    </footer>
  );
}
